<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-testid="saving-icon"
  >
    <path d="m16.63,11.99l-13.39,0l-0.20,0c-1.77,-0.20 -3.03,-1.63 -3.03,-3.48c0,-1.84 1.46,-3.38 3.34,-3.38c0.10,0 0.20,0 0.41,0l0.41,0.10l0.10,-0.40c0.20,-0.71 0.62,-1.43 1.15,-1.94c0.62,-0.51 1.36,-0.71 2.09,-0.71c0.52,0 1.04,0.10 1.46,0.30l0.52,0.20l0.20,-0.51c0.52,-1.33 1.77,-2.15 3.13,-2.15c1.88,0 3.34,1.53 3.34,3.38c0,0.30 0,0.71 -0.10,1.02l-0.20,0.61l0.62,0c1.77,0.10 3.24,1.63 3.24,3.38c0,0.81 -0.31,1.63 -0.94,2.35c-0.52,0.61 -1.36,1.02 -2.19,1.12l0,0.10z" />
  </svg>
</template>

<script>
export default {
  name: 'SavingIcon',
  props: {
    size: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      width: this.size,
      height: (this.size * 12) / 20,
    };
  },
};
</script>
<style scoped lang="scss">
  svg {
    width: v-bind('width + "px"');
    height: v-bind('height + "px"');
    margin: v-bind('(width / 4) + "px"');
    fill: #DDDDDD;
    stroke: main.$midGray;
  }
</style>
